import React, { PropTypes } from 'react'

import './ChangingAliadasAvatars.scss'
import Avatar from 'components/Avatar'

const ChangingAliadasAvatars = ({ replacedAliada, replacementAliada }) => (
  <div className='ChangingAliadasAvatars'>
    <div className='ChangingAliadasAvatars-replacedAliadaAvatar'>
      <Avatar
        image={replacedAliada.profilePicture.original}
        superaliada={replacedAliada.superaliada}
        size={60}
        />
    </div>

    <div className='ChangingAliadasAvatars-replacementAliadaAvatar'>
      <Avatar
        image={replacementAliada.profilePicture.original}
        superaliada={replacementAliada.superaliada}
        size={60}
        />
    </div>

    <span
      className='ChangingAliadasAvatars-icon icon-cached'
      />
  </div>
)

ChangingAliadasAvatars.displayName = 'ChangingAliadasAvatars'
ChangingAliadasAvatars.propTypes = {
  replacedAliada: PropTypes.object.isRequired,
  replacementAliada: PropTypes.object.isRequired
}

export default ChangingAliadasAvatars



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/ChangeAliadaConfirmBase/components/ChangingAliadasAvatars/ChangingAliadasAvatars.js